import { URLS, MARKETING_LINKS } from 'consts';

export const navItems = [
  {
    label: 'Careers and Community',
    helptext: 'Moms, dads, and allies',
    children: [
      {
        label: 'Finding Work',
        href: URLS.talentCommunity,
        target: '_self',
      },
      {
        label: 'Mentoring',
        href: MARKETING_LINKS.rallyProgram,
        target: '_self',
      },
      {
        label: 'Upskilling',
        href: MARKETING_LINKS.workRise,
        target: '_self',
      },
      {
        label: 'Advice and Resources',
        href: URLS.careerGuidance,
        target: '_self',
      },
    ],
  },
  {
    label: 'Small Companies',
    helptext: 'Companies with 1-499 employees',
    children: [
      {
        label: 'How It Works',
        href: URLS.howItWorksSMB,
        target: '_self',
      },
      {
        label: 'Plans and Pricing',
        href: URLS.pricing,
        target: '_self',
      },
      {
        label: 'Tips and Resources',
        href: URLS.werkSpace,
        target: '_self',
      },
    ],
  },
  {
    label: 'Enterprise',
    helptext: 'Companies with 500+ employees',
    children: [
      {
        label: 'How It Works',
        href: URLS.howItWorksEnterprise,
        target: '_self',
      },
      {
        label: 'Plans and Pricing',
        href: URLS.pricing,
        target: '_self',
      },
      {
        label: 'WerkLabs Custom Insights',
        href: URLS.werklabsInsights,
        target: '_blank',
      },
      {
        label: 'DEI Thought Leadership',
        href: URLS.werklabsLeadership,
        target: '_blank',
      },
      {
        label: 'Tips and Resources',
        href: URLS.werkSpace,
        target: '_self',
      },
    ],
  },
  {
    label: 'About',
    href: URLS.about,
    target: '_self',
  },
];
